'use client';
// 一鍵往上 超過廣告 banner 一半高度顯示

import { useState, useEffect, useCallback } from 'react';
import Image from 'next/image';

const GoTop = () => {
    // 顯示與否
    const [showGoTop, setShowGoTop] = useState(false);

    // 一鍵往上
    const goTop = () => window.scrollTo({ top: 0 });

    const handleGoTop = useCallback(() => {
        const el = document.querySelector('#list-ad');

        if (!el) return;

        const top = window.scrollY;
        const threshold = el.offsetTop + el.clientHeight / 2;
        setShowGoTop(top > threshold);
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleGoTop);

        return () => window.removeEventListener('scroll', handleGoTop);
    }, [handleGoTop]);

    return showGoTop ? (
        <div className="flex justify-end items-end flex-grow z-[0] go-top">
            <button
                className="sticky bottom-[25px] center-center flex-col mb-[25px] bg-black"
                onClick={goTop}
            >
                <span>
                    <Image
                        className="mix-blend-color-burn"
                        width={45}
                        height={45}
                        src="/images/icon/icon_top.gif"
                        alt="icon"
                    />
                    <span className="text-btn1b text-[#AA82C3]">TOP</span>
                </span>
            </button>
        </div>
    ) : (
        <></>
    );
};

export default GoTop;
